'use client';

import { useEffect, useRef } from 'react';
import { useSearchParams } from 'next/navigation';
import { useOptionalLoginModals } from './LoginModalsManager';

/**
 * Opens the login modal for query params other parts of the system use to request sign-in
 * (`openLogin`, `session_expired`, `partner_login_error`), mounted on the landing page.
 * Not stripped here — LoginModal itself reads these to pick which banner to show.
 */
export function OpenLoginFromQuery() {
  const searchParams = useSearchParams();
  const openLoginModal = useOptionalLoginModals()?.openLoginModal;
  const didOpenRef = useRef(false);

  const wants =
    searchParams?.get('openLogin') === '1' ||
    searchParams?.get('session_expired') === '1' ||
    searchParams?.get('partner_login_error') === '1';

  useEffect(() => {
    if (!wants || !openLoginModal || didOpenRef.current) return;
    didOpenRef.current = true;
    openLoginModal();
  }, [wants, openLoginModal]);

  return null;
}
